export const METRO_AREAS = [
  { code: 'NYC', label: 'New York (All)', airports: ['JFK', 'EWR', 'LGA'] },
  { code: 'LON', label: 'London (All)', airports: ['LHR', 'LGW', 'STN', 'LTN'] },
  { code: 'PAR', label: 'Paris (All)', airports: ['CDG', 'ORY'] },
  { code: 'TYO', label: 'Tokyo (All)', airports: ['NRT', 'HND'] },
  { code: 'WAS', label: 'Washington DC (All)', airports: ['IAD', 'DCA', 'BWI'] },
  { code: 'CHI', label: 'Chicago (All)', airports: ['ORD', 'MDW'] },
  { code: 'LAX', label: 'Los Angeles (All)', airports: ['LAX', 'BUR', 'SNA', 'ONT'] },
  { code: 'SFO', label: 'San Francisco (All)', airports: ['SFO', 'OAK', 'SJC'] },
  { code: 'MIA', label: 'Miami (All)', airports: ['MIA', 'FLL'] },
  { code: 'DXB', label: 'Dubai (All)', airports: ['DXB', 'DWC'] },
  { code: 'BKK', label: 'Bangkok (All)', airports: ['BKK', 'DMK'] },
  { code: 'SHA', label: 'Shanghai (All)', airports: ['PVG', 'SHA'] },
];

export const METRO_AREAS_BY_CODE = new Map(METRO_AREAS.map((m) => [m.code, m]));
